import request from "../../utils/MYINCOME/request";

export interface IGetUserInfo {
  userNo: string;
}
export interface IGetUserInfoReturn {
  userCode: string;
  deptName: string;
  imgUrl: string;
  notExamines: {
    createBy: string;
    createTime: string;
    id: number;
    month: string;
    userNumber: string;
  }[];
  recruday: string;
  userName: string;
}
/**
 * 获取人员信息
 * @param
 */
export const getUserInfo = (params: IGetUserInfo) =>
  request<IGetUserInfoReturn>({
    method: "GET",
    url: "/plrs-target/userInfo",
    params,
  });

export type Store = {
  flag: string;
  storeId: string;
  storeName: string;
  beginDate: string;
  endDate: string;
  employeeId: string;
};

type getUserInfoByUserNoResponseType = {
  position: string;
  stores: Store[];
  userName: string;
  scoreQtd?: string;
  scoreQtdMonth?: string;
  storeCount?: string;
  storeTimeVOList?: any[];
  userImgUrl?: string;
};

/**
 * 根据工号查询个人信息
 * @param userNo 用户No
 */
export const getUserInfoByUserNo = (userNo: string) =>
  request<getUserInfoByUserNoResponseType>({
    method: "GET",
    url: `/plrs-adviser/user/getUserInfoByUserNo/${userNo}`,
  });

export interface IPullMsgItem {
  endTime: string;
  id: string;
  pushContent: string;
  pushFrequency: string;
  pushTitle: string;
  startTime: string;
}
// 拉取推送的信息
export function pullMsg(userNo: string): Promise<{ data: IPullMsgItem[] }> {
  return request({
    url: `/plrs-manager/tipMsgPush/msgPushList/${userNo}`,
    method: "get",
  });
}

export interface IReachTipReturn {
  differVal: number; //差额
  maxSpuName: string; //差距最大spu
  minSpuName: string; //差距最小spu
  nameVal: string; //应达成值名称
  remind: boolean; //提示提醒
  timeVal: string; //时间（月/季度）
}
export function reachTip(queryNo: string): Promise<{ data: IReachTipReturn }> {
  return request({
    url: `/plrs-target/productIncome/reachTip/${queryNo}`,
    method: "get",
  });
}

export interface ILoginSignRequest {
  userNo: string;
  token: string;
  sign: string;
}
export interface ILoginSignReturn {
  position: string;
  token: string;
}
// /** 换取token **/
export function loginSign(
  data: ILoginSignRequest
): Promise<{ data: ILoginSignReturn }> {
  return request({
    url: "/plrs-adviser/user/loginNormal",
    method: "post",
    data,
  });
}

export interface IIncomeParams {
  actualAmt: number; //实际业绩;
  actualIncome: number; //实际收入;
  actualRatio: number; //实际收入比例;
  brandName: string; //品牌;
  cateName: string; //品类名称;
  custName: string; //客户名称
  custNum: string; //客户编码
  gapAmt: number; //业绩差距
  gapIncome: number; //预期收入差距
  gapIncomeActual: number; //实际收入差距
  goalAmt: number; //目标业绩
  goalIncome: number; //目标收入
  predictAmt: number; //预测业绩
  predictIncome: number; //预测收入
  predictRatio: number; //预测收入比例
  spuName: string; //SPU名称
  stockAmt: number; //存量业绩
  strategicGrade: number; //策略等级
}
export interface IGetStatListRequest {
  employeeNo: string; //人员工号
  month: string; //月份:2022-12,季度-2022Q1,半年度-2022H1
  keyword?: string; //搜索关键词
  group: string | null; //分组数据:brand-品牌,cate-品类,spu-SPU,cust-客户
  brandName: string; //品牌名称
  cateName: string | null; //品类名称
  sortField: string | null; //排序字段-参考列表返回字段:goalAmt-目标业绩....
  sortType: string; //排序方式:DESC|ASC
  targetCode: string | null; //指标编码:RES_IPO2_GTMT_SPU,RES_IPO4_GTMT_SPU,RES_IPO10_GTMT_SPU
  isStrategic: string | null; //策略品:Y-是
  custNum?: string | null; //来源:客户编码
  isDom?: boolean; //是否为DOM数据
}
export interface IGetStatListReturn {
  actualAmt: number; //实际业绩
  incomeList: IIncomeParams[]; //产品收入列表
  isShow: string; //是否展示同期:Y-展示,N-不展示
  stockAmt: number; //存量业绩
  strategicInfo: IIncomeParams; //产品收入请求参数
  performanceList: IIncomeParams[]; //产品收入列表 --todo 待修改，根据接口实际返回值
}
// 列表统计
export function getStatList(
  params: IGetStatListRequest
): Promise<{ data: IGetStatListReturn }> {
  return request({
    url: "/plrs-target/productIncome/stat",
    method: "get",
    params,
  });
}

// DOM接口返回的单条数据类型
export interface IGetDomStatListReturn {
  actualAmt: number; //实际业绩
  actualIncome: number; //实际收入
  actualRatio: number; //实际收入比例
  brandName: string; //品牌
  cateName: string; //品类名称
  custName: string; //客户名称
  custNum: string; //客户编码
  gapAmt: number; //业绩差距
  gapIncome: number; //预期收入差距
  gapIncomeActual: number; //实际收入差距
  goalAmt: number; //目标业绩
  goalIncome: number; //目标收入
  predictAmt: number; //预测业绩
  predictIncome: number; //预测收入
  predictRatio: number; //预测收入比例
  spuName: string; //SPU名称
  stockAmt: number; //存量业绩
  strategicGrade: number; //策略等级
}

// DOM列表统计
export function getDomStatList(
  params: IGetStatListRequest
): Promise<{ data: IGetDomStatListReturn }> {
  return request({
    url: "/plrs-target/userIncome/stat/dom",
    method: "get",
    params,
  });
}
export interface IGetIncomeThresholdReturn {
  actualName: string; //业绩名称
  actualVal: number; //业绩值
  goalName: string; //目标名称
  goalVal: number; //目标值
  isLock: boolean; //是否锁住
}
// 收入门槛值获取
export function getIncomeThreshold(
  params: IGetStatListRequest
): Promise<{ data: IGetIncomeThresholdReturn[] }> {
  return request({
    url: "/plrs-target/productIncome/statLimit",
    method: "get",
    params,
  });
}
export interface IGetIncomeThresholdNewItem {
  conditionCode: string; //条件编码
  actualName: string; //业绩名称
  actualVal: number; //业绩值
  goalName: string; //目标名称
  goalVal: number; //目标值
  isLock: boolean; //是否锁住
}
// 新结构：外层数组每个元素是一组（且），组与组之间是或
export type IGetIncomeThresholdNewReturn = IGetIncomeThresholdNewItem[][];

// 收入门槛值获取（新）
export function getIncomeThresholdNew(
  params: IGetStatListRequest
): Promise<{ data: IGetIncomeThresholdNewReturn }> {
  return request({
    url: "/plrs-target/productIncome/statLimitGroup",
    method: "get",
    params,
  });
}
export interface IGetUserIncomeStatReturnCommonParams {
  actualIncome: number; //实际收入
  gapIncome: number; //预期收入差距
  gapIncomeActual: number; //实际收入差距
  goalIncome: number; //目标收入
  predictIncome: number; //预测收入
}
export interface IGetUserIncomeStatRequest {
  employeeNo: string; //人员工号
  month: string; //月度:2022-12,季度:2022Q1(1~4代表4个季度),半年:2022H1(1上半年,2下半年)
}
export interface IGetUserIncomeStatReturn {
  achievementSalary: IGetUserIncomeStatReturnCommonParams;
  basicSalary: IGetUserIncomeStatReturnCommonParams;
  positionSalary: IGetUserIncomeStatReturnCommonParams;
  domSalary?: IGetUserIncomeStatReturnCommonParams;
}
// 全部收入
export function getUserIncomeStat(
  params: IGetUserIncomeStatRequest
): Promise<{ data: IGetUserIncomeStatReturn }> {
  return request({
    url: "/plrs-target/userIncome/stat",
    method: "get",
    params,
  });
}

export interface IGetSalaryAchievementReturnIncomeParams {
  actualIncome: number; //实际收入
  gapIncome: number; //预期收入差距
  gapIncomeActual: number; //实际收入差距
  goalIncome: number; //目标收入
  predictIncome: number; //预测收入
}
export interface IGetSalaryAchievementParams {
  employeeNo: string; //人员工号
  month: string; //月度:2022-12,季度:2022Q1(1~4代表4个季度),半年:2022H1(1上半年,2下半年)
}
export interface IGetSalaryAchievementReturn {
  halfYearReward: {
    actualAmt: number; //达成额
    employeeNo: string; //人员工号
    goalAmt: number; //目标额
    month: string; //月份
    overAmt: number; //超额
    paramRatio: number; //系数
    paramSys: string; //参数体系:员工/管理
    reward: number; //超额奖金
  }[]; //半年度销量绩效
  monthIncome: IGetSalaryAchievementReturnIncomeParams;
  quarterIncome: IGetSalaryAchievementReturnIncomeParams;
  halfYearIncome: IGetSalaryAchievementReturnIncomeParams;
  monthDomIncome?: IGetSalaryAchievementReturnIncomeParams;
  quarterDomIncome?: IGetSalaryAchievementReturnIncomeParams;
  halfYearDomIncome?: IGetSalaryAchievementReturnIncomeParams;
  yearDomIncome?: IGetSalaryAchievementReturnIncomeParams;
}
// 首页绩效工资
export function getSalaryAchievement(
  params: IGetSalaryAchievementParams
): Promise<{ data: IGetSalaryAchievementReturn }> {
  return request({
    url: "/plrs-target/userIncome/salary/achievement",
    method: "get",
    params,
  });
}

export interface IGetSalaryImplementParams {
  employeeNo: string; //人员工号
  month: string; //月度:2022-12,季度:2022Q1(1~4代表4个季度),半年:2022H1(1上半年,2下半年)
}
export interface IGetSalaryImplementReturn {
  actualIncome: number; //实际收入
  gapIncome: number; //预期收入差距
  gapIncomeActual: number; //实际收入差距
  goalIncome: number; //目标收入
  predictIncome: number; //预测收入
}
// 首页执行绩效工资
export function getSalaryImplement(
  params: IGetSalaryImplementParams
): Promise<{ data: IGetSalaryImplementReturn }> {
  return request({
    url: "/plrs-target/userIncome/salary/implement",
    method: "get",
    params,
  });
}

export interface IGetSalaryBasicParams {
  employeeNo: string;
  month: string;
}
export interface IGetSalaryBasicReturn {
  actualIncome: number;
  gapIncome: number; //预期收入差距
  gapIncomeActual: number; //实际收入差距
  goalIncome: number;
  predictIncome: number;
}
// 首页基本工资
export function getSalaryBasic(
  params: IGetSalaryBasicParams
): Promise<{ data: IGetSalaryBasicReturn }> {
  return request({
    url: "/plrs-target/userIncome/salary/basic",
    method: "get",
    params,
  });
}

export interface IGetSalaryPositionParams {
  employeeNo: string;
  month: string;
}
export interface IGetSalaryPositionReturn {
  actualIncome: number;
  gapIncome: number; //预期收入差距
  gapIncomeActual: number; //实际收入差距
  goalIncome: number;
  predictIncome: number;
}
// 首页岗位工资
export function getSalaryPosition(
  params: IGetSalaryPositionParams
): Promise<{ data: IGetSalaryPositionReturn }> {
  return request({
    url: "/plrs-target/userIncome/salary/position",
    method: "get",
    params,
  });
}

export interface IGetUserIncomeSaleReturnCommonParams {
  actualIncome: number;
  gapIncome: number; //预期收入差距
  gapIncomeActual: number; //实际收入差距
  goalIncome: number;
  predictIncome: number;
}

export interface IChildrenItem {
  actualIncome: number;
  gapIncome: number;
  gapIncomeActual: number;
  goalIncome: number;
  predictIncome: number;
  name: string;
}
export interface IGetUserIncomeSaleParams {
  employeeNo: string;
  month: string;
}
export interface IGetUserIncomeSaleReturn {
  achievementIncome: IGetUserIncomeSaleReturnCommonParams;
  ipo10Income: IGetUserIncomeSaleReturnCommonParams;
  ipo2Income: IGetUserIncomeSaleReturnCommonParams;
  ipo4Income: IGetUserIncomeSaleReturnCommonParams;
  spuData: {
    RES_IPO10_GTMT_SPU: {
      actualIncome: number; //实际收入
      gapIncome: number; //预期收入差距
      gapIncomeActual: number; //实际收入差距
      goalIncome: number; //目标收入
      predictIncome: number; //预测收入
      children?: IChildrenItem[];
    };
    RES_IPO4_GTMT_SPU: {
      actualIncome: number; //实际收入
      gapIncome: number; //预期收入差距
      gapIncomeActual: number; //实际收入差距
      goalIncome: number; //目标收入
      predictIncome: number; //预测收入
      children?: IChildrenItem[];
    };
    RES_IPO8_GTMT_SPU: {
      actualIncome: number; //实际收入
      gapIncome: number; //预期收入差距
      gapIncomeActual: number; //实际收入差距
      goalIncome: number; //目标收入
      predictIncome: number; //预测收入
      children?: IChildrenItem[];
    };
    RES_IPO2_GTMT_SPU: {
      actualIncome: number; //实际收入
      gapIncome: number; //预期收入差距
      gapIncomeActual: number; //实际收入差距
      goalIncome: number; //目标收入
      predictIncome: number; //预测收入
      children?: IChildrenItem[];
    };
    RES_IPO2_HFH_SPU_YTM: {
      actualIncome: number; //实际收入
      gapIncome: number; //预期收入差距
      gapIncomeActual: number; //实际收入差距
      goalIncome: number; //目标收入
      predictIncome: number; //预测收入
      children?: IChildrenItem[];
    };
    RES_IPO2_HFH_SPU: {
      actualIncome: number; //实际收入
      gapIncome: number; //预期收入差距
      gapIncomeActual: number; //实际收入差距
      goalIncome: number; //目标收入
      predictIncome: number; //预测收入
      children?: IChildrenItem[];
    };
    RES_IPO4_HFH_SPU: {
      actualIncome: number; //实际收入
      gapIncome: number; //预期收入差距
      gapIncomeActual: number; //实际收入差距
      goalIncome: number; //目标收入
      predictIncome: number; //预测收入
      children?: IChildrenItem[];
    };
    RES_IPO8_HFH_SPU: {
      actualIncome: number; //实际收入
      gapIncome: number; //预期收入差距
      gapIncomeActual: number; //实际收入差距
      goalIncome: number; //目标收入
      predictIncome: number; //预测收入
      children?: IChildrenItem[];
    };
    RES_IPO10_HFH_SPU: {
      actualIncome: number; //实际收入
      gapIncome: number; //预期收入差距
      gapIncomeActual: number; //实际收入差距
      goalIncome: number; //目标收入
      predictIncome: number; //预测收入
      children?: IChildrenItem[];
    };
  };
}
// 绩效收入_销量绩效
export function getUserIncomeSale(
  params: IGetUserIncomeSaleParams
): Promise<{ data: IGetUserIncomeSaleReturn }> {
  return request({
    url: "/plrs-target/userIncome/sale",
    method: "get",
    params,
  });
}

export interface IGetTargetsParams {
  versionDate: string;
  userNo: string;
}
export interface IGetTargetsReturn {
  targets: IGetTargetsReturnCommonParams[];
  cashNum?: IGetTargetsReturnCommonParams;
  cashRatio?: IGetTargetsReturnCommonParams;
  executeNum?: IGetTargetsReturnCommonParams;
  executeRatio?: IGetTargetsReturnCommonParams;
  saleNum?: IGetTargetsReturnCommonParams;
  saleRatio?: IGetTargetsReturnCommonParams;
}
export interface IAchieveVOS {
  achType: string;
  comType: string;
  createBy: string;
  createTime: string;
  due: string;
  id: string;
  node: string;
  payType: string;
  positionId: number;
  start: string;
  updateBy: string;
  updateTime: string;
}
export interface IChildren {
  childActual: string;
  childDescription: string;
  childDone: string;
  childTarget: string;
}
export interface IGetTargetsReturnCommonParams {
  achieveVOS: IAchieveVOS[];
  acture: string;
  aim: string;
  category: string;
  categoryName: string;
  children: IChildren[];
  code: string;
  customDone: string;
  dataSource: string;
  due: string;
  highDone: string;
  id: string;
  isCheck: string;
  lastModified: string;
  modifier: string;
  position: string;
  purpose: string;
  sort: number;
  start: string;
  stateLabel: string;
  weight: string;
}
// 执行绩效指标
export function getTargets(
  params: IGetTargetsParams
): Promise<{ data: IGetTargetsReturn }> {
  return request({
    url: "/plrs-target/template/targets",
    method: "get",
    params,
  });
}

export interface IGetTargetSketchReturn {
  achieveVOS: IAchieveVOS;
  acture: string;
  aim: string;
  category: string;
  categoryName: string;
  children: {
    childActual: string;
    childDescription: string;
    childDone: string;
    childTarget: string;
  }[];
  code: string;
  customDone: string;
  dataSource: string;
  due: string;
  highDone: string;
  id: string;
  isCheck: string;
  lastModified: string;
  modifier: string;
  position: string;
  purpose: string;
  sort: number;
  start: string;
  stateLabel: string;
  weight: string;
}
// 执行绩效指标规则
export function getTargetSketch(
  code: string
): Promise<{ data: IGetTargetSketchReturn }> {
  return request({
    url: `/plrs-gateway/plrs-target/target/${code}`,
    method: "get",
  });
}

export interface IBuryRecordParams {
  code: string;
  id: number | null;
  sysCode: string;
  userNumber?: string;
}
// /** 埋点接口 **/
export function buryRecord(data: IBuryRecordParams): Promise<{ data: number }> {
  return request({
    url: "/plrs-manager/bury/record",
    method: "post",
    data,
  });
}

export interface IGetProjectInspireOverviewReturn {
  endDate: string; //结束日期
  frequency: string; //频率:日-D/月-M
  id: string; //id
  position: string; //考核岗
  startDate: string; //开始日期
  targetCode: string; //激励项编码
  targetName: string; //激励项名称
}
// 人员激励奖金规则
export function getProjectInspireOverview(
  employeeNo: string,
  month: string
): Promise<{ data: IGetProjectInspireOverviewReturn[] }> {
  return request({
    url: "/plrs-target/incentive-reward",
    method: "get",
    params: { employeeNo, month },
  });
}

export interface IGetProjectInspireDetailReturn {
  actualIncome: number; //实际收入
  date: string; //日期:月份/到日
  detailList: {
    //详情列表
    name: string; //详情名称
    value: number; //详情值
  }[];
  scope: string; //计算范围:M-到月,D-到日
}
export function getProjectInspireDetail(params: {
  ruleId: string;
  employeeNo: string;
  month?: string;
  year?: string;
}): Promise<{ data: IGetProjectInspireDetailReturn[] }> {
  return request({
    url: `/plrs-target/incentive-reward/${params.ruleId}`,
    method: "get",
    params,
  });
}

// 人员激励奖金统计 项目激励
export interface IGetProjectInspireStatReturn {
  nums?: number; //激励项目数量
  reward?: number; //奖金总额
}
export function getProjectInspireStat(
  employeeNo: string,
  month: string
): Promise<{ data: IGetProjectInspireStatReturn }> {
  return request({
    url: `/plrs-target/incentive-reward/stat`,
    method: "get",
    params: { employeeNo, month },
  });
}

// 新的IPO统计接口(2025年7月开始使用)
export interface IGetUserIncomeStatIpoParams {
  employeeNo: string;
  month: string;
}

export interface IUserIncomeStatIpoCommonParams {
  actualIncome: number; //实际收入
  gapIncome: number; //预期收入差距
  gapIncomeActual: number; //实际收入差距
  goalIncome: number; //目标收入
  isDom: boolean; //是否Dom
  predictIncome: number; //预测收入
  targetCode: string; //指标编码
  targetName: string; //指标名称
}

export interface IGetUserIncomeStatIpoReturn {
  achievementIncome: IUserIncomeStatIpoCommonParams;
  ipoList: {
    node: IUserIncomeStatIpoCommonParams;
    subNodeList: IUserIncomeStatIpoCommonParams[];
  }[];
  spuData: {
    [key: string]: IUserIncomeStatIpoCommonParams;
  };
}

// 绩效收入_销量绩效_IPO统计
export function getUserIncomeStatIpo(
  params: IGetUserIncomeStatIpoParams
): Promise<{ data: IGetUserIncomeStatIpoReturn }> {
  return request({
    url: "/plrs-target/userIncome/stat/ipo",
    method: "get",
    params,
  });
}
